import LabSettings from "./Components/Pages/LabSettings";
import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from "react-router-dom";
import Login from "./Components/Pages/Login";
import WaitingScreen from "./Components/Pages/WaitingScreen";
import AppContainer from "./Components/Containers/AppContainer";
import Home from "./Components/Pages/Home";
import Profile from "./Components/Pages/Profile";
import LastAppointments from "./Components/Pages/LastAppointments";
import RoomsMonitoring from "./Components/Pages/Room/RoomsMonitoring";
import RoomHistory from "./Components/Pages/Room/RoomHistory";
import Statistics from "./Components/Pages/Statistics";
import UploadVideo from "./Components/Pages/Video/UploadVideo";
import ManagementVideo from "./Components/Pages/Video/ManagementVideo";
import AllVideo from "./Components/Pages/Video/AllVideo";
import EditVideo from "./Components/Pages/Video/EditVideo";
import AttribVideo from "./Components/Pages/Video/AttribVideo";
import Signup from "./Components/Pages/CreateUser";
import UserManagement from "./Components/Pages/UserManagement";
import StatisticsBeta from "./Components/Pages/StatisticsBeta";
import RecentComments from "./Components/Pages/random";
import UpdateOldDocuments from "./Components/Pages/DeleteOldFolders";
import SecretaryBackoffice from "./Components/Pages/SecretaryBackoffice";
import Filet from "./Components/Elements/Filet";
import FileModeDirect from "./Components/Pages/FileModeDirect";
import DossiersWorkbench from "./Components/Pages/DossiersWorkbench";
import Indicateurs from "./Components/Pages/Indicateurs";
import FileEnvoi from "./Components/Pages/FileEnvoi";
import GardeConnexion from "./Components/Containers/GardeConnexion";
// La question « voulez-vous vraiment quitter cette page ? » est posee par
// la page elle-meme quand elle sait le faire, et par le navigateur sinon.
import { demanderConfirmationNavigation } from "./Utils/confirmationNavigation";

export default function Routes() {
  // Synchroniser laboratory et currentLab uniquement lors de la connexion initiale
  useEffect(() => {
    const laboratory = localStorage.getItem("laboratory");
    const currentLab = localStorage.getItem("currentLab");

    // On s'assure que currentLab est défini si laboratory existe
    // mais uniquement si l'utilisateur vient de se connecter (pas de currentLab défini)
    if (laboratory && !currentLab) {
      localStorage.setItem("currentLab", laboratory);
    }

    // On ne fait plus la synchronisation forcée qui empêchait le changement de laboratoire
  }, []);

  return (
    <Router getUserConfirmation={demanderConfirmationNavigation}>
      <Switch>
        <Route path="/login">
          <Login />
        </Route>
        <Route path="/waitingScreen">
          <WaitingScreen />
        </Route>
        {/* La session est celle de Firebase Auth, verifiee par le SDK — plus
            une cle localStorage que n'importe qui peut poser. En mode
            demonstration la garde est court-circuitee : voir Utils/demoMode.js. */}
        <GardeConnexion>
        <AppContainer>
          <Route path="/home">
            <Home />
          </Route>
          <Route path="/roomsMonitoring">
            <RoomsMonitoring />
          </Route>

          <Route path="/roomHistory">
            <RoomHistory />
          </Route>
          <Route path="/lastAppointments">
            <LastAppointments />
          </Route>
          <Route path="/statistics">
            <Statistics />
          </Route>
          <Route path="/uploadVideo">
            <UploadVideo />
          </Route>
          <Route path="/managementVideo">
            <ManagementVideo />
          </Route>
          <Route path="/editVideo">
            <EditVideo />
          </Route>
          <Route path="/userProfile">
            <Profile />
          </Route>
          <Route path="/allvideo">
            <AllVideo />
          </Route>
          <Route path="/attribVideo">
            <AttribVideo />
          </Route>
          <Route path="/createuser">
            <Signup />
          </Route>
          {/*
              22/09 : CETTE ROUTE NE MONTRAIT PAS L'ECRAN QU'ELLE NOMME.

              `/usersmanagment` rendait `UpdateOldDocuments` — l'ecran de
              maintenance « Mise a jour des documents anciens ». `UserManagement`
              etait importe en haut de ce fichier et n'etait rendu NULLE PART :
              verifie, son nom n'apparaissait dans aucune autre ligne du depot.

              C'est la vraie raison pour laquelle Nicolas n'a jamais pu
              distribuer les acces. L'ecran a ete ecrit le 08/09 pour repondre a
              « donne moi en Admin la possibilite d'associer ces fonctions
              uniquement a quelques utilisateurs » ; depuis, il n'etait
              atteignable par aucun chemin, pas meme en tapant son adresse. On
              croyait la fonction livree, elle ne l'a jamais ete.

              L'ecran de maintenance garde une route a lui, sous un nom qui dit
              ce qu'il fait. */}
          <Route path="/usersmanagment">
            <UserManagement />
          </Route>
          <Route path="/documentsAnciens">
            <UpdateOldDocuments />
          </Route>
            <Route path="/random">
            <RecentComments></RecentComments>
          </Route>
          

          <Route path="/labSettings">
            <LabSettings />
          </Route>

          <Route path="/secretaryBackoffice">
            {/* Le filet de la page entiere : si la liste elle-meme casse, on
                garde le menu et un message, pas un ecran blanc. */}
            <Filet zone="secretariat" titre="Le secrétariat s'est arrêté">
              <SecretaryBackoffice />
            </Filet>
          </Route>
          <Route path="/fileModeDirect">
            <FileModeDirect />
          </Route>
          <Route path="/dossiers">
            <DossiersWorkbench />
          </Route>
          <Route path="/fileEnvoi">
            <FileEnvoi />
          </Route>
          <Route path="/indicateurs">
            <Indicateurs />
          </Route>
          <Route path="/statisticsBeta">
            <StatisticsBeta />
          </Route>
        </AppContainer>
        </GardeConnexion>
      </Switch>
    </Router>
  );
}
